module.exports = __webpack_public_path__ + "img/corneal-neovascularisation-4.b12df135.jpg";